<template>
  <PageHeader :title="$t('ui.entities.user.role.admin')"></PageHeader>
</template>

<script setup>
import PageHeader from '@/components/page/PageHeader.vue'
</script>

<style></style>
